// W-0829 — Grid detalhe dos SubTipos do Tipo selecionado.
// Fonte Delphi: UResultadoAtend.pas (grid inferior). Colunas: codigo (read-only), descricao.
// Incluir desabilitado sem Tipo selecionado (sem cod_atendimento dono). Editar/Excluir exigem
// SubTipo selecionado. Reusa TabelaDinamica.

import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { FaPlus, FaEdit, FaTrash } from 'react-icons/fa';
import Tabela from '~/Components/TabelaDinamica/Tabela';

const GridSubTipos = ({
  subTipos,
  tipoSelecionado,
  subTipoSelecionado,
  onSelecionarSubTipo,
  onIncluir,
  onEditar,
  onExcluir,
}) => {
  const temTipo = !!tipoSelecionado;
  const temSubSelecao = !!subTipoSelecionado;

  const colunas = [
    { title: 'Código', key: 'codigo', align: 'right', width: '110px' },
    { title: 'Descrição', key: 'descricao' },
  ];

  // PK composta (cod_atendimento, codigo) compõe a key estável.
  const dados = (subTipos || []).map((s) => ({
    ...s,
    id: `sub-${s.cod_atendimento}-${s.codigo}`,
  }));

  return (
    <Card className="mb-3">
      <Card.Header className="d-flex justify-content-between align-items-center flex-wrap" style={{ gap: 8 }}>
        <strong>
          SubTipos{tipoSelecionado ? ` — ${tipoSelecionado.descricao}` : ''}
        </strong>
        <div className="d-flex" style={{ gap: 8 }}>
          <Button variant="success" size="sm" disabled={!temTipo} onClick={onIncluir}>
            <FaPlus /> Incluir
          </Button>
          <Button
            variant="primary"
            size="sm"
            disabled={!temSubSelecao}
            onClick={() => temSubSelecao && onEditar(subTipoSelecionado)}
          >
            <FaEdit /> Editar
          </Button>
          <Button
            variant="danger"
            size="sm"
            disabled={!temSubSelecao}
            onClick={() => temSubSelecao && onExcluir(subTipoSelecionado)}
          >
            <FaTrash /> Excluir
          </Button>
        </div>
      </Card.Header>
      <Card.Body className="p-2">
        <Tabela
          colunas={colunas}
          dados={dados}
          fontSize="13px"
          cliqueLinha={(item) => onSelecionarSubTipo(item)}
          linhaSelecionada={(item) =>
            subTipoSelecionado &&
            item.codigo === subTipoSelecionado.codigo &&
            item.cod_atendimento === subTipoSelecionado.cod_atendimento
          }
        />
      </Card.Body>
    </Card>
  );
};

export default GridSubTipos;
